import React from 'react'

const ReturnandRefundPolicy = () => {
    const returnandrefund =`Last updated on Mar 15th 2024

    Welcome to Cambri, your premier destination for IELTS Course Prep. By accessing and using our services, you're agreeing to our Terms of Use, shaped by compliance with international standards and tailored to meet regulations in the USA, Britain, Canada, and India. Please review these terms carefully before using our services.

    <strong>1. Acceptance of Terms</strong>

    By using Cambri's services, you agree to these Terms of Use, applicable to all users worldwide, with specific considerations for local laws in the USA, Britain, Canada, and India.

    <strong>2. User Eligibility and Consent</strong>

    •	<strong>Global:</strong> Users must be 18 years or older. For those under 18, parental or guardian consent is required.
    •	<strong>India Specific:</strong> Compliance with the Indian Contract Act, 1872; users must be at least 18 years old or have parental consent.

    <strong>3. User Registration and Security</strong>

    Responsibility for maintaining the confidentiality of your account and password lies with you. Cambri retains the right to terminate accounts or edit content at its discretion, adhering to local laws in the USA, Britain, Canada, and India.

    <strong>4. License to Use and Payment Policy</strong>

    Cambri grants you a non-exclusive, non-transferable license for personal, non-commercial use of our services, respecting copyright laws and intellectual property rights across all jurisdictions.

    You agree to pay Cambri the fee specified in the Payment Form during the Period. Fees are non-refundable and non-transferable once you initiate access to Cambri’s services or content after registering with your user account.

    <strong>5. Intellectual Property Rights</strong>

    Content and materials provided by Cambri are protected under copyright laws. Unauthorized use is prohibited, with due respect to the laws of the USA, Britain, Canada, and India.

    <strong>6. User-Generated Content</strong>

    You're responsible for any content you create, share, or post. This content must not infringe on others' rights or contain illegal material, and must be aligned with the legal standards of each jurisdiction mentioned.

    <strong>7. Prohibited Conduct</strong>

    Users must not engage in activities that harm the service or violate the rights of others, including spamming, spreading malware, or engaging in unlawful activities, with specific attention to digital conduct laws in the mentioned countries.

    <strong>8. Liability Limitations</strong>

    UNDER NO CIRCUMSTANCES, INCLUDING, BUT NOT LIMITED TO, NEGLIGENCE, SHALL CAMBRI OR ITS AFFILIATES, CONTRACTORS, EMPLOYEES, OFFICERS, DIRECTORS, AGENTS, OR THIRD PARTY PARTNERS, LICENSORS, OR SERVICE PROVIDERS BE LIABLE TO YOU FOR ANY SPECIAL, INDIRECT, INCIDENTAL, CONSEQUENTIAL, OR EXEMPLARY DAMAGES THAT ARISE OUT OF OR RELATE TO THE SERVICE, INCLUDING YOUR USE THEREOF, EVEN IF THE COMPANY OR A COMPANY AUTHORIZED REPRESENTATIVE HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.

    <strong>9. Amendments and Errata</strong>

    Cambri reserves the right to modify these Terms at any time, with changes becoming effective upon posting. Users are encouraged to review these Terms periodically.

    <strong>10. Governing Law</strong>

    •	<strong>Global:</strong> These Terms are governed by the laws of Delaware, USA, with respect to international users.
    •	<strong>Region-Specific Adjustments:</strong> Consideration is given to the local laws of Britain, Canada, and India for users in those jurisdictions.

    <strong>11. Dispute Resolution</strong>

    •	<strong>Global and USA:</strong> Disputes will be resolved through arbitration in Delaware, USA.
    •	<strong>Britain, Canada, India:</strong> Adjustments made to adhere to local dispute resolution mechanisms and consumer protection laws.

    <strong>12. Privacy and Electronic Communications</strong>
   
    By using Cambri's services, you consent to electronic communications and agree to Cambri's Privacy Policy, which aligns with GDPR in Britain, PIPEDA in Canada, and respective privacy laws in the USA and India.

    <strong>13. Comprehensive Agreement</strong>

    These Terms constitute the entire agreement between you and Cambri regarding service use, superseding any prior agreements or communications.
    `
  return (
    <div className="p-4 w-3/4 mx-auto">
      <h1 className="p-4 text-center text-4xl font-bold">CAMBRI</h1>
      <div className="bg-gray-100 p-6 rounded-lg shadow-md">
        <h2 className="text-2xl font-semibold mb-4">Return & Refund Policy : </h2>
        <p className="whitespace-pre-line" dangerouslySetInnerHTML={{__html: returnandrefund}}></p>
      </div>
    </div>
  )
}

export default ReturnandRefundPolicy
